<a
  class="menu-item-btn"
  [attr.href]="link() || null"
  [attr.target]="link() ? target() : null"
  draggable="false"
  [class.hover-effect]="hoverEffect()"
  [class]="type()"
>
  @if (icon) {
    <rt-icon
      class="right-icon"
      [name]="icon"
      [size]="iconSize()"
      [colorToken]="$any(isActive() ? 'colorIconPrimaryDefault' : 'colorIconStrongDefault')"
    />
  } @else {
    <div class="right-icon">
      <ng-content select="[icon]" />
    </div>
  }
  @if (!!buttonText) {
    <rt-truncate variant="default">
      <span class="btn-text" [class.has-text]="!!buttonText">{{ buttonText }}</span>
    </rt-truncate>
  }

  @if (rightIcon) {
    <rt-icon
      class="left-icon"
      [name]="rightIcon"
      [size]="iconSize()"
      colorToken="colorIconStrongDefault"
    />
  }

  <div class="indicator">
    <ng-content select="[indicator-content]" />
  </div>
  <div class="container-walkthrough-tooltip-item-anchor">
    <ng-content select="[walkthrough-tooltip-item-anchor]" />
  </div>
  <div class="check-icon">
    <ng-content select="[check-icon]" />
  </div>
  <div class="menu-divider">
    <ng-content select="[menu-divider]" />
  </div>
</a>
